// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--2cb60","flipped":"styles-module--flipped--6e17d"};